import { differenceInDays, isBefore } from "date-fns";
import { parseDate } from "helpers";
import { ICampaignServer } from "model/campaigns";
import { LineitemRunningStateServer } from "model/lineitems";
import React from "react";
import { getRunningCampaignsList } from "redux/campaignStatus/campaignStatusSelectors";
import { getCampaignsLineitemsStatusServerObject } from "redux/campaignStatus/statusServerSelectors";
import { useSelector } from "redux/hooks";
import { CampaignPageNotificationType, NotificationReason } from "../types";
import { getNotificationId } from "./helper";

const generateNotifications = (
  campaigns: Array<ICampaignServer>,
  lineitemsStatusObject
) => {
  const notifications: Array<CampaignPageNotificationType> = [];
  const reason = NotificationReason.lineitemEndsIn3days;
  const { Running } = LineitemRunningStateServer;

  campaigns.forEach((c) => {
    if (!c.lineitems) return;

    const today = new Date();

    c.lineitems.forEach((l) => {
      const startDate = parseDate(l.start) as Date;
      const finishDate = parseDate(l.finish) as Date;
      const runState =
        lineitemsStatusObject[c.id]?.lineitems?.[l.id]?.lineitemState?.runState;
      const isRunning = runState === Running;
      const endsInTheFuture = isBefore(today, finishDate);
      const isLongerThan7Days = differenceInDays(finishDate, startDate) > 7;
      const endsSoon = differenceInDays(finishDate, today) < 3;

      if (isRunning && endsInTheFuture && isLongerThan7Days && endsSoon) {
        notifications.push({
          id: getNotificationId({ campaign: c, lineitem: l, reason }),
          campaignId: c.id,
          campaignName: c.name,
          lineitemId: l.id,
          lineitemName: l.name,
          reason,
        });
      }
    });
  });

  return notifications;
};

export default function useLineitemEndNotifications() {
  const campaignsList: ICampaignServer[] = useSelector(getRunningCampaignsList);

  const lineitemsStatusObject: { [key: string]: any } = useSelector(
    getCampaignsLineitemsStatusServerObject
  );
  const syncNotifications: Array<CampaignPageNotificationType> = React.useMemo(
    () => generateNotifications(campaignsList, lineitemsStatusObject),
    [campaignsList, lineitemsStatusObject]
  );

  return syncNotifications;
}
